import { render, staticRenderFns } from "./SummaryVisaOfficePage.vue?vue&type=template&id=324a09ac&scoped=true&"
import script from "./SummaryVisaOfficePage.vue?vue&type=script&lang=js&"
export * from "./SummaryVisaOfficePage.vue?vue&type=script&lang=js&"
import style0 from "./SummaryVisaOfficePage.vue?vue&type=style&index=0&id=324a09ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a09ac",
  null
  
)

export default component.exports